
  import { defineComponent, PropType } from "vue";

  import CardDescription from "@/components/base-card/card-partials/card-content/card-body/CardDescription.vue";
  import CardImage from "@/components/base-card/card-partials/card-content/card-body/CardImage.vue";
  import CardInfoRow from "@/components/base-card/card-partials/card-content/card-body/CardInfoRow.vue";
  import CardTab from "@/components/base-card/card-partials/card-content/card-body/CardTab.vue";
  import CardText from "@/components/base-card/card-partials/card-content/card-body/CardText.vue";
  import VueProgressBar from "@/components/VueProgressBar.vue";
  import { Component } from "@/components/base-card/CustomTypes";

  export default defineComponent({
    name: "CardBody",

    components: { CardDescription, CardImage, CardInfoRow, CardTab, CardText, VueProgressBar },

    props: {
      body: {
        type: Object as PropType<{ [key: string]: Component }>,
        required: true,
      },
    },
  });
